import * as React from "react";
import { SVGProps } from "react";

const Bluzelle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 455 470" {...props}>
    <path
      fill="#fdba4d"
      d="M65.45 336.92a40.62 40.62 0 1 1-.15.15l.15-.15M343.54 72.91a40.66 40.66 0 1 1 0 57.5 40.62 40.62 0 0 1-.05-57.41h.05M117.59 305.64l42.9 42.9 39.3-39.3a77.42 77.42 0 0 1-43-43ZM310.5 200.67l39.3-39.3-42.9-42.9-39.3 39.3a77.35 77.35 0 0 1 25.9 17.1 75.64 75.64 0 0 1 17 25.8"
    />
    <path
      fill="#5da9dd"
      d="M342.17 392.39a40.66 40.66 0 1 1 57.5 0 40.62 40.62 0 0 1-57.45.05l-.05-.05M69.53 126.79a40.66 40.66 0 1 1 57.5 0 40.62 40.62 0 0 1-57.45 0m234.08 220.04 42.9-42.9-39.3-39.3a77.42 77.42 0 0 1-43 43m-61.19-152.09-39.3-39.3-42.9 42.9 39.3 39.3a77.35 77.35 0 0 1 17.1-25.9 75.64 75.64 0 0 1 25.8-17"
    />
    <path
      fill="#18568c"
      d="M274.92 40.7a40.67 40.67 0 1 1 0-.06v.06m0 388.74a40.67 40.67 0 1 1 0-.06ZM249 102.7h-25.6v50.4a74.86 74.86 0 0 1 25.6 0m0 166.16a74.86 74.86 0 0 1-25.6 0v50.4H249"
    />
    <path
      fill="#18578c"
      d="M414.3 264.63a40.67 40.67 0 1 1 .06 0h-.06m-373.6 6.91a40.7 40.7 0 1 1 40.7-40.71 40.7 40.7 0 0 1-40.7 40.71m270.11-27.9h50.4V218h-50.4a74.86 74.86 0 0 1 0 25.6Zm-156.6 0a74.86 74.86 0 0 1 0-25.6h-50.4v25.6"
    />
    <path
      fill="#18568b"
      d="M290.7 233.84a57.7 57.7 0 1 1-57.7-57.7 57.72 57.72 0 0 1 57.7 57.7Z"
    />
  </svg>
);

export default Bluzelle;
